<template>
  <div>
    <!-- 注册-->
    <Modal
      v-model="succers"
      width="500px"
      class-name="vertical-center-modal"
      :mask-closable="false"
      @on-cancel="cancel()"
    >
      <div style="min-height: 300px; padding: 40px 60px">
        <div class="zhuce">注册</div>
        <Form
          ref="formItems"
          :model="formItems"
          :rules="ruleInfo"
          :label-width="0"
        >
          <FormItem class="liItem" prop="phone">
            <img
              style="width: 22px; height: 25px"
              src="@/assets/images/inpone.png"
            />
            <Input
              height="50px"
              v-model="formItems.phone"
              placeholder="请输入您的手机号"
              @keyup.enter.native="keyupClick('mima')"
            >
            </Input>
          </FormItem>
          <FormItem class="liItem myPasswordInput" prop="passwords">
            <img
              style="width: 22px; height: 25px"
              src="@/assets/images/suo.png"
            />
            <Input
              height="50px"
              type="password"
              v-model="formItems.passwords"
              placeholder="请输入您的密码"
              ref="mima"
              password
              @keyup.enter.native="keyupClick('code')"
            >
            </Input>
          </FormItem>
          <FormItem class="liItem top_input" prop="validate">
            <img
              style="width: 23px; height: 25px"
              src="@/assets/images/dui.png"
            />
            <Input
              style="height: 50px"
              v-model="formItems.validate"
              placeholder="请输入动态密码"
              ref="code"
              @keyup.enter.native="zhuces('formItems')"
            ></Input
            ><Button
              v-if="codeList"
              @click="getCode('formItems')"
              style="position: absolute; top: 0px; right: 0px; width: 100px; height: 45px"
            >
              获取验证码</Button
            >
            <Button
              v-if="!codeList"
              style="position: absolute; top: 0px; right: 0px; width: 100px; height: 45px"
              >{{ times }}秒</Button
            >
          </FormItem>
          <FormItem>
            <Button
              style="width: 100%; height: 40px"
              @click="zhuces('formItems')"
              type="primary"
              >注册</Button
            >
          </FormItem>
          <div style="font-size:14px;margin-top:14px;">
            <Checkbox v-model="agree"> </Checkbox> 我已阅读并接受<span
              @click="show = true"
              style="color: #4064e1; cursor: pointer;"
              >&nbsp&nbsp用户协议</span
            >
          </div>
        </Form>
      </div>
      <div slot="footer"></div>
      <VerifyCode
        ref="verifyCode"
        :show="showVerifyCode"
        :phone="formItems.phone"
        @success="handleVerifySuccess"
        @close="handleVerifyClose"
      ></VerifyCode>
    </Modal>
    <modalfiles
      v-if="listGive"
      :listGive="listGive"
      :liaveTive="liaveTive"
      :dataList="dataList"
      @gitlist="gitlist"
    ></modalfiles>
    <agreement :show="show" @fun="getAgree"></agreement>
  </div>
</template>
<script>
import DataApi from '@/api/login'
import VerifyCode from '@/views/home/components/VerifyCode.vue'
import modalfiles from '@/components/Modalfiels/index.vue'
import agreement from '@/components/agreement'

import {
  email,
  realName,
  password,
  select,
  upload,
  empty,
  phone,
  identity,
  verificationCode,
  pws,
  selectcity
} from '@/const/formValidate'
var vm
export default {
  props: {
    topgit: {
      type: Boolean,
      default: null
    }
  },
  name: '',
  data () {
    return {
      showVerifyCode: false,
      listGive: false,
      liaveTive: 1,
      formItems: {
        phone: '',
        passwords: '',
        validate: ''
      },
      succers: this.topgit,
      times: '', // 验证码获取时间
      codeList: true,
      count: null,
      ruleInfo: {
        phone: phone('你的手机号'),
        passwords: empty('你的密码'),
        verifyStatus: [
          {
            validator: () => this.$refs.verifyRef.status,
            message: '请拖动滑块进行验证',
            trigger: 'blur'
          }
        ]
        // validate: empty("你的验证码"),
      },
      show: false,
      agree: false
    }
  },
  components: { modalfiles, agreement: agreement, VerifyCode },

  watch: {
    topgit: {
      handler (item) {
        this.succers = item
        //  this.$emit("topgitnew", this.succers);
        // this.$nextTick(function () {
        //   vm.cancel();
        // });
      },
      deep: true,
      immediate: true
    },
    succers: {
      handler (item) {
        this.succers = item
        //  this.$emit("topgitnew", this.succers);
        // this.$nextTick(function () {
        //   vm.cancel();
        // });
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    vm = this
  },
  mounted () {
    this.$root.Bus.$on('text', function (msg) {
      vm.succers = msg
    })
  },
  methods: {
    gitlist (names) {
      this.listGive = names
    },
    keyupClick (name) {
      this.$nextTick(() => {
        vm.$refs[name].focus()
      })
    },
    cancel (name) {
      this.succers = false
      this.$emit('topgitnew', this.succers)
    },
    getCode (name) {
      var inputs = /^1[3456789]\d{9}$/

      if (!vm.formItems.phone) {
        return this.$Message.error('请先输入手机号!')
      }

      if (!inputs.test(vm.formItems.phone)) {
        return this.$Message.error('请输入正确的手机号!')
      }

      // 校验手机号是否注册
      DataApi.accountIsExist({
        account: vm.formItems.phone
      }).then(res => {
        if (!res.data) {
          return this.$Message.error('该手机号已被注册')
        }
        this.showVerifyCode = true
      })
    },
    handleVerifyClose () {
      this.showVerifyCode = false
    },
    handleVerifySuccess () {
      this.showVerifyCode = false
      if (this.times) return
      this.yanzheng()
    },
    yanzheng () {
      var data = {
        phone: vm.formItems.phone,
        adapter: 'regiter'
      }
      DataApi.regiteList(data)
        .then(res => {
          if (res.messageType == 'Success') {
            // this.codeList = false;
            this.$Message.success('发送成功！')
            const TIME_COUNT = 60
            if (this.codeList) {
              this.times = TIME_COUNT
              this.codeList = false // 设置倒计时秒
              this.times = 60
              var count = setInterval(() => {
                this.times--
                if (this.times <= 0) {
                  this.codeList = true
                  clearInterval(count)
                }
              }, 1000)
            }
          } else {
            this.$Message.destroy()
            this.$Message.error(res.resultDesc)
          }
        })
        .catch(err => {})
    },
    zhuces (name) {
      this.$refs[name].validate(valid => {
        if (!this.agree) {
          this.$Message.destroy()
          this.$Message.warning('请同意用户协议后再注册')
          return
        }
        if (valid && vm.formItems.validate != '') {
          var data = {
            password: vm.formItems.passwords,
            username: vm.formItems.phone,
            validateCode: vm.formItems.validate
          }
          // gatherEdit: true,
          DataApi.userList(data).then(res => {
            if (res.messageType == 'Success') {
              this.dataList = data
              this.succers = false
              this.listGive = true
              this.$emit('topgitnew', false)

              this.$Message.success(res.resultDesc)
            } else {
              this.$Message.destroy()
              this.$Message.error(res.resultDesc)
            }
          })
        } else {
          this.$Message.destroy()
          this.$Message.error('请完善您的信息!')
        }
      })
    },
    getAgree (data) {
      vm.agree = data
      vm.show = false
    }
  }
}
</script>
<style scoped="scoped" lang="less">
.flex_left {
  display: flex;
  justify-content: space-between;
}

/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
/deep/ .ivu-input {
  height: 45px;
  padding-left: 55px;
}
.zhuce {
  padding-top: 0px;
  padding-bottom: 30px;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2150cb;
  line-height: 24px;
}
.liItem {
  position: relative;
}
.liItem img {
  display: block;
  position: absolute;
  top: 10px;
  left: 15px;
  z-index: 999999;
}
.top_input /deep/ .ivu-input {
  width: 240px;
}
/deep/.ivu-modal-footer {
  display: none;
}

.myPasswordInput /deep/ .ivu-icon {
  font-size: 22px;
  line-height: 42px;
}
</style>
